export default "__VITE_ASSET__DvLrr5W7__"